import React from 'react';
import { withRouter } from 'react-router';
import { compose } from 'recompose';

import { authService } from '../../utils/auth-service';
import hasUserInfo from '../../hocs/has-user-info';
import hasJSONAPIClient from '../../hocs/has-jsonapi-client';


class NewInfluencerWelcome extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    this.loadInfluencer();
  }
  loadInfluencer = () => {
    const profile = authService.getProfile();
    const organisationId = profile.app_metadata.dyzio.o_id;

    const { jsonAPIClient } = this.props;
    jsonAPIClient.get('organisations', organisationId, { include: ['influencer'] })
      .then(organisation => organisation.toJSONTree())
      .then(org => {
        const { influencer } = org;
        this.setState({
          influencer,
        });
      })
      .catch(e => {
        console.log(e);
      });
  }
  render() {
    const { influencer } = this.state;
    if (!influencer) return null;

    const { setupComplete } = influencer;
    if (!setupComplete) {
      this.props.history.push('/new-influencer/registration');
      return null;
    }
    return (
      <pre>{JSON.stringify(influencer, null, ' ')}</pre>
    );
  }
}

export default compose(
  withRouter,
  hasJSONAPIClient,
  hasUserInfo,
)(NewInfluencerWelcome);



/** WEBPACK FOOTER **
 ** ./src/containers/new-influencer-profile/index.js
 **/